var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item-group',{staticClass:"alert"},_vm._l((_vm.alerts),function(alert){return _c('v-alert',{key:alert.id,attrs:{"type":alert.type || 'error'}},[_vm._v(" "+_vm._s(alert.msg)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }